import { createPlugin } from '@front/utils/alpine';
import { DataLayer } from '@front/services/datalayer';
import { isArray, isPlainObject, isString } from 'lodash-es';
var EAllowedTriggers;
(function (EAllowedTriggers) {
    EAllowedTriggers["CLICK"] = "click";
    EAllowedTriggers["SUBMIT"] = "submit";
})(EAllowedTriggers || (EAllowedTriggers = {}));
var EAllowedActions;
(function (EAllowedActions) {
    EAllowedActions["EMIT"] = "emit";
    EAllowedActions["PUSH"] = "push";
})(EAllowedActions || (EAllowedActions = {}));
const isValidAction = (action) => Object.values(EAllowedActions).includes(action);
const isValidTrigger = (trigger) => Object.values(EAllowedTriggers).includes(trigger);
export default createPlugin((vm) => {
    const ACTIONS = {
        emit: (event, el, originalEvent) => {
            if (!isString(event)) {
                throw `[dl] invalid type for payload '${event}'`;
            }
            DataLayer.emit(event, el, originalEvent);
        },
        push: (payload) => {
            if (!isArray(payload) && !isPlainObject(payload)) {
                throw `[dl] invalid type for payload '${payload}'`;
            }
            DataLayer.push(payload);
        },
    };
    vm.magic('dl', (el) => ({
        emit: (event, originalEvent) => ACTIONS.emit(event, el, originalEvent),
        push: (payload, originalEvent) => ACTIONS.push(payload, el, originalEvent),
    }));
    vm.directive('dl', (el, { value, modifiers, expression }, { evaluate, cleanup }) => {
        const action = value;
        const [trigger, ...rest] = modifiers;
        if (rest.length > 0) {
            throw `[dl] only one trigger is allowed.`;
        }
        if (!isValidTrigger(trigger)) {
            throw `[dl] trigger '${trigger}' is not allowed.`;
        }
        if (!isValidAction(action)) {
            throw `[dl] action '${action}' is not allowed.`;
        }
        const handler = (originalEvent) => {
            ACTIONS[action](evaluate(expression), el, originalEvent);
        };
        el.addEventListener(trigger, handler);
        cleanup(() => {
            el.removeEventListener(trigger, handler);
        });
    });
});
